import zenScroll from 'zenscroll';
import Util from './util';

const Navigation = {
	Init() {
		// Using the current path (e.g. /Section/Page)
		let path = window.location.pathname;

		Navigation.Go(path);
		path = window.location.search;
		Navigation.Go(path);

		if (path.indexOf('print=true') >= 0) {
			window.print();
		}

		Navigation.Accordion();
	},
	Go(url) {
		// Handle links to the current path
		if (url) {
			$(`a[href$="${url}"]:not([href^="http"])`)
				.addClass('active')
				.parents()
				.filter('li')
				.addClass('active');

			// Handle links to parts of the current path
			const parts = url.split('/');
			parts.forEach(part => {
				$(`a[href$="/${part}"]`)
					.addClass('active')
					.parents()
					.filter('li')
					.addClass('active');
			});
		}
	},
	Accordion() {
		$('#accordionEducationalMaterials').on('click', '.btn-collapse', function accordion() {
			const $target = $(this).attr('href');
			Util.UpdateUrlHash($target);
			setTimeout(() => {
				zenScroll.to(document.querySelector($target));
			}, 500);
		});

		if (document.location.href.toLowerCase().indexOf('sun-smart-toolkits') >= 0) {
			if (document.location.hash !== undefined && document.location.hash.length > 0) {
				$(`a[href="${document.location.hash}"]`).click();
			}
		}
	}
};

export default Navigation;
